<template>
	<div>
		<h2
			class="center"
			v-html="`Ecco cosa ne pensa chi ci ha provato`"
		/>

		<h3 v-if="template === 'home'">Più di 500 000 cene risolte</h3>

		<div :class="{'usp flex': !orderNow, 'flex': orderNow}">
			<div class="usp-title">
				<div class="fdt_widget_wrapper" v-if="!orderNow ">
 					<img src="//www.feedaty.com/rating/ratev2-small-4.1.png" alt="voto">
				</div>
			</div>
			<div class="row">
				<div
					v-for="(opinion, index) in opinions"
					class="opinion center"
					:key="index"
				>
					<div
						class="text-bold"
						v-html="opinion.name"
					/>
					<div>
						<i class="fa fa-star" v-for="i in 5" :key="i" />
					</div>

					<div
						v-html="opinion.message"
					/>
				</div>
			</div>
		</div>

		<based-on v-if="$route.name !== 'order-now'"/>

  </div>
</template>

<script>

import BasedOn from '@/components/Parts/BasedOn'
import Feedaty from '@/components/Feedaty'


export default {

	components: {
		BasedOn,
		Feedaty
	},

	props: {
		template: {
			type: String,
			default: 'plans'
		},
		orderNow: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			opinions: []
		}
	},

	mounted () {
		if(this.orderNow && this.$route.name === 'order-now-voiello') {
			this.opinions.push({
				message: `"Una box fantastica e prodotti davvero buoni. In più molto bello ricevere anche le schede ricette con tutte le istruzioni"`,
				name: `Maria`
			})

			this.opinions.push({
				message: '"Ho ricevuto questa box in regalo e sono rimasto davvero stupito dalla qualità delle materie prime"',
				name: `Francesco`
			})

			this.opinions.push({
				message: '"Bellissima iniziativa a sostegno di Procida. Ricette buone e facili da preparare ma con dei sapori davvero intensi"',
				name: `Lucia`
			})
		}else {
			this.opinions.push({
				message: this.$t(`components.opinions.${ this.template }.opinion_1`),
				name: this.$t(`components.opinions.${ this.template }.name_1`)
			})

			this.opinions.push({
				message: this.$t(`components.opinions.${ this.template }.opinion_2`),
				name: this.$t(`components.opinions.${ this.template }.name_2`)
			})

			this.opinions.push({
				message: this.$t(`components.opinions.${ this.template }.opinion_3`),
				name: this.$t(`components.opinions.${ this.template }.name_3`)
			})
		}
	}

}

</script>

<style scoped>
h3 {
	padding-bottom: 10px;
	text-align: center;
}
.row {
	margin: 0 -10px;
}

.usp {
	margin: 20px 0;
}

.usp-title {
	padding: 0;
}

.fa-star {
	color: #e55418;
}

.faq {
	flex-wrap: nowrap;
}

.opinion {
	flex-grow: 1;
	flex-basis: calc(100% / 3 - 20px);
	min-width: 240px;
	padding: 10px;
}

@media (max-width: 1024px) {
	.usp {
		flex-direction: column;
	}
}

</style>
